import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { max } from 'lodash';
import { AvailableModulesItemCount, TenantDto } from 'shared';
import { NotificationService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { AddTenantModulesDialogComponent } from '../add-tenant-modules-dialog/add-tenant-modules-dialog.component';

@Component({
    selector: 'tenant-contract-info',
    templateUrl: './edit-tenant-contract.component.html',
    styleUrls: ['./edit-tenant-contract.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EditTenantContractComponent implements OnInit {

  @Input('tenant') tenant!:TenantDto;
  
  editTenantForm!:UntypedFormGroup;
  systemType!:string;
  isForSystemTest: boolean = false;
  availableModules: AvailableModulesItemCount[] = [];

  preview: string | ArrayBuffer | null = null;
  // byteArray: Uint8Array | null = null;
  byteArray: any[] | null = null;

  constructor(private fb: UntypedFormBuilder, 
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private tenantService: TenantService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    //console.log("----------------> tenant-contract tenant: ", this.tenant)
    this.tenantService.currentTenantName = this.tenant.name;
    this.tenantService.currentTenantId = this.tenant.id;
    this.systemType = this.tenant.systemType;
    this.isForSystemTest = this.tenant.isForSystemTest;

    const json = this.tenant.additionalModules;
    if (json)
      this.availableModules = JSON.parse(json);
    this.buildTenantForm(this.tenant);
  }

  buildTenantForm(tenant: TenantDto) {
    this.editTenantForm = this.fb.group({
      id:[tenant.id],
      name:[tenant.displayName],
      maxUserCount: [tenant.maxUserCount],
      maxProjectCount: [tenant.maxProjectCount],
      invitationValidForDays: [tenant.invitationValidForDays],
      additionalModules: [tenant.additionalModules],
      //isForSystemTest: [tenant.isForSystemTest]
    })
  }

  editTenant(){
    if(this.editTenantForm.valid){
      let tenant = new TenantDto;
      tenant = this.tenant;
      tenant.maxUserCount = this.editTenantForm.value.maxUserCount;
      tenant.maxProjectCount = this.editTenantForm.value.maxProjectCount;
      tenant.invitationValidForDays = this.editTenantForm.value.invitationValidForDays;
      tenant.additionalModules = this.editTenantForm.value.additionalModules;
      //tenant.isForSystemTest = this.editTenantForm.value.isForSystemTest;

      // console.log("-----------> zu aktualisierender Mandant: ", tenant);

      this.tenantService.updateTenancy(tenant).subscribe({
        next:() => {
          // console.log("-----------> Mandant erfolgreich aktualisiert: ", tenant);
          this.notificationService.success(``, 'Daten erfolgreich aktualisiert');
          //this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-tenants']);
        },
        error:(error:any) => {
          this.notificationService.error(``, 'update-tenant-failed' + ': ' + error.message);
        }
      });
    }
  }

  cancel() {
    this.tenantService.currentTenantName = "SM";
    this.tenantService.currentTenantId = "";
    this.router.navigate(['/', 'SM', 'manage-tenants']);
  }

  addModule() {
    const dialogRef = this.dialog.open(AddTenantModulesDialogComponent, { width: '800px', data: this.availableModules });
      dialogRef.afterClosed().subscribe((result: any) => { 
        // this.availableModules = (result != undefined && result != null) ? result : [];
        const availableModules = (result != undefined && result != null) ? result : [];

        console.log("-------> add-tenant-modules-dialog result modules: ", availableModules)
        if(availableModules.length > 0) {
          this.availableModules = availableModules;
          const jsonData = JSON.stringify(this.availableModules);
          this.editTenantForm.get('additionalModules')!.setValue(jsonData);              

          this.editTenant();
        }
      },
      //error
    );
  }
}
